<script>
import axios from "axios";
import apigeneric from "../helpers/apigeneric";
import Api from "@/helpers/apibtoast"; 

/**
 * Nav-bar Component
 */
export default {
  mixins: [ apigeneric,Api],
  data() {
    return {
      lang: "tr",
      text: null,
      flag: null,
      value: null,
      languages: [
        {
          flag: require("@/assets/images/flags/tr.jpg"),
          language: "tr",
          title: "Türkçe",
        },
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "Spanish",
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic",
        },
      ],
      MenuRoleKontrol:false, 
      Bildirimler: [],
      intervalId: null,
      lastRun: null,
    };
  },
  components: {},
  mounted() {
    this.MuneRolesControl();
  
    this.intervalId = setInterval(this.BildirimGet, 5 * 60 * 1000);
  },
  beforeUnmount() { 
    clearInterval(this.intervalId);
  },
  methods: {MuneRolesControl() {   
      let YetkiSorgu = this.UserRolles.filter((item) =>
        item.includes("SuperAdmin") || item.includes("TlpAdmin")
      );
      if (YetkiSorgu.length != 0) this.MenuRoleKontrol = true; 
    },
    Get(){
 
    if (!window.$cookies.get("ecampususer")) {
      this.BildirimGet();
    }
    },
    BildirimGet(){

      this.lastRun = new Date().toLocaleTimeString();
      this.ActionsFilterGet({
        Service: "tlptalepbildirim",
        FullData: true,
        Filter: "&Desc=Created&Tip=1&Personelid=" + this.TokenPersonelId + "&Okundu=false",
      }).then((res) => {
        this.Bildirimler = res.Data; 
      });

    },
    BildirimOkundu(Data){
        Data.Okundu = true
        this.Update("tlptalepbildirim", Data, "Mesaj Okundu")
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },

    logoutUser() {
      // eslint-disable-next-line no-unused-vars
      axios.get("http://127.0.0.1:8000/api/logout").then((res) => {
        this.$router.push({
          name: "default",
        });
      });
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="/assets/images/Kurum_Logo_sm.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="/assets/images/Kurum_Logo.png" alt height="22" />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="/assets/images/Kurum_Logo_sm.png" alt height="30" />
            </span>
            <span class="logo-lg">
              <img src="/assets/images/Kurum_Logo.png" alt height="40" />
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <!-- App Search-->
        <form class="app-search d-none d-lg-block">
          <div class="position-relative">
            <input
              type="text"
              class="form-control"
              :placeholder="$t('navbar.search.text')"
            />
            <span class="bx bx-search-alt"></span>
          </div>
        </form>
      </div>

      <div class="d-flex">
  

    


        <div class="dropdown d-inline-block">
                            <button type="button" class="btn header-item noti-icon waves-effect show" id="page-header-notifications-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                <i class="bx bx-bell bx-tada"></i>
                                <span class="badge bg-danger rounded-pill"><font style="vertical-align: inherit;">
                                  <font style="vertical-align: inherit;">{{ Bildirimler.length }}</font></font></span>
                            </button>
                            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 " 
                            aria-labelledby="page-header-notifications-dropdown" 
                            style="position: absolute; inset: 0px 0px auto auto; margin: 0px; transform: translate(0px, 72px);" data-popper-placement="bottom-end">
                                <div class="p-3">
                                    <div class="row align-items-center">
                                        <div class="col">
                                            <h6 class="m-0" key="t-notifications"><font style="vertical-align: inherit;">
                                              <font style="vertical-align: inherit;">Bildirimler</font>
                                            </font></h6>
                                        </div> 
                                    </div>
                                </div>
                                <div data-simplebar="init" style="max-height: 230px;" class="simplebar-scrollable-y"><div class="simplebar-wrapper" style="margin: 0px;"><div class="simplebar-height-auto-observer-wrapper"><div class="simplebar-height-auto-observer"></div></div><div class="simplebar-mask"><div class="simplebar-offset" style="right: 0px; bottom: 0px;"><div class="simplebar-content-wrapper" tabindex="0" role="region" aria-label="kaydırılabilir içerik" style="height: auto; overflow: hidden scroll;"><div class="simplebar-content" style="padding: 0px;">
                                    <a href="javascript: void(0);" @click="BildirimOkundu(Data)" class="text-reset notification-item" v-for="(Data,index) in Bildirimler" :key="index">
                                        <div class="d-flex">
                                            <div class="avatar-xs me-3">
                                                <span class="avatar-title   rounded-circle font-size-16">
                                                    <i class="bx bx-bell bx-tada"></i>
                                                </span>
                                            </div>
                                            <div class="flex-grow-1">
                                                <h6 class="mb-1" key="t-your-order"  v-if="0"><font style="vertical-align: inherit;">
                                                  <font style="vertical-align: inherit;">{{Data.Mesaj}}</font></font></h6>
                                                <div class="font-size-12 text-muted">
                                                    <p class="mb-1" key="t-grammer"><font style="vertical-align: inherit;">
                                                      <font style="vertical-align: inherit;">{{Data.Mesaj}}</font></font></p>
                                                    <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 
                                                      <span key="t-min-ago"><font style="vertical-align: inherit;">
                                                        <font style="vertical-align: inherit;">{{ formatDateTableTime(Data.Created) }}</font></font></span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </a> 
                                </div></div></div></div><div class="simplebar-placeholder" style="width: 320px; height: 352px;"></div></div><div class="simplebar-track simplebar-horizontal" style="visibility: hidden;"><div class="simplebar-scrollbar" style="width: 0px; display: none;"></div></div><div class="simplebar-track simplebar-vertical" style="visibility: visible;"><div class="simplebar-scrollbar" style="height: 150px; display: block; transform: translate3d(0px, 0px, 0px);"></div></div></div>
                                <div class="p-2 border-top d-grid">
                                    <a class="btn btn-sm btn-link font-size-14 text-center" href="/tlptalepbildirim">
                                        <i class="mdi mdi-arrow-right-circle me-1"></i> 
                                        <span key="t-view-more"><font style="vertical-align: inherit;">
                                          <font style="vertical-align: inherit;">Daha Fazlasını Gör..</font></font></span> 
                                    </a>
                                </div>
                            </div>
                        </div>





        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              :src="
                Avatar
                  ? Avatar
                  : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAeCAMAAACR41cYAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAJ/UExURUdwTCEgIB8fHyAfHyAfHyAfHyAfHx8eHiAfHx8eHiAfHyAfHyAfHx8eHiAfH5jU5h8eHiAfHyAfHyAfHx8eHh8eHiAfHyAfIAQBAxgWFiEhISEgIAwCACAgIB0bGi40NhkVFCAfH5za8FBncENVXKTm95vZ8Jza8J7c8R0bGhMTEx0cHCAfHyEgH73//yEgIJ7c8QAAAIfF6TM7PwwJCh4cHHm45SAfHyAfH5za8CAfH5za8Jza8Jza8Jza8CAfH5za8G6VokRVWxIKCJza8JvY7pza8DtITTlFSZ3b8AMHCgAABJza8ElBPDA4PFVLRK3z/zEvLRcXGEVBPTA5PJza8AADB5vZ74XD6QIAAIrJ67T+/4HA6BAIByAfH4zK7IrI6zE4O7D5/yAfHwEAACIgIJza8BUWGAACBhoaGvXLsQ0PEZ/g957c8RATFf/oy1p4hfzRticqLIC+6Jrm///jxiMiIvDEq//Xu/bHq//fxG5eVRgXF////P/z0P/22lNHQv/gv//877H5/xcTEhUOC76cicyolCcjIf/avdivlpvY7mZaUQMHC1lNRfrNsPTJr//o0v/cwf3WuHtnXIshF4VuYvTEqfrcyM+oqOrW1PTm4v716zM7PqHf8v/t1SkpJsD//1RueGebxaPn/IXK/TVIV3OapbmXheK0mNuymv/GrdWZhu/Tx+u7pI54adymkf/658+dlMifn+S1mafq+7uhizYvLeLCufLs7/rk1mNVTf/NrtOskqeHd8aXlXFgVv/kwZU1LNW1neK9tJAuJsCMirJwa+nKv9zFx2CRtVuKronG6naszSUnKUZaZG+TmUFPU3agr3GkxIu8xSfH+3sAAABzdFJOUwD97RwqJTMat/4VL6DlCwmSOh2qV77yhGEIms8njIj9+xEk6wESA6CMcwRtUGQlwnjIs9iu9u3fsS5e3hvwhB66hguP9eJfotdT9nPf4o7mPNW62Kc/5MnTMeRzzcTG3/LkYv////////////////////54WQMpAAACTklEQVQYGXXABVMiYRgA4BdYdhkExa5TR8Xuvu7u7v5g2V06XFGxO7C72+vu7s74Qaczd87sIg/85yeUJMMCsUK+FFzIEEISvwSZxF8iSwpEczyBT4L4xMAXhniE4CIQ8QRgwCMWID458PgipEYag0ZD07TGYHCgOcuBI1GIWA3lqEcOrVbrUNdXUzSLfIHDB7EG7fXGi411tRdq6y7dedrl1KjTgGMNop3PSm+WGO35+fkNHSUlpT0U8geO4ABneUX7w9tXWxmGKXzU/7HyyX2tBLhCVT0vh/q7b7W3MW1Fb169H6p4TIXAP1IRQfiIMV/qRUXl8+4HHUwnY//w9l1lZ7kzHBP7EIRICpg3juMemLd2zGwcHOjrLbjB9PYNDI72sgYc88Bx3BsDQiSN9FQCpFDFxrKyVvO1KwXmwtGy0i4qBUDpGSkVEbDA73D5vYIGo/2y3Vhkfl28PQl4NoQABAdl79vV0lzc3LLnwP4dBPB4rbNkwbwM1byMRHAVk7qe3gIAyWpWIBCwKAgWFTS8dfdBQY5cIMsRsv6wuARLhIU+rUBhKCQgFNwIPrYkTR6uVqjD80LBvWxhIFKgsLxT4IYy9XyWJbo6ujo64tyJvbGwiM1H9OM/kalmosb0bXhct2m1F/DExpG6KZPqxy/Vd9XsrGriro5cEQVcUSSp05s+T0XU/HGM6T6Z9DqSjAcur7Vkk77KNjnzu+rrzKStSt9ErloGfOk7yRGr1Tb9ZdpmtY6QG+NWgivlofTMk2dyz+YeP5oZvy0GFvwFlSbPVswTomsAAAAASUVORK5CYII='
              "
              :alt="UserNameSurName"
            />
            <span class="d-none d-xl-inline-block ms-1">{{
              UserNameSurName
            }}</span> 
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template> 
          <b-dropdown-item v-if="MenuRoleKontrol">
            <router-link tag="span" to="/userroles">
              <i class="mdi mdi-eye-off font-size-16 align-middle me-1"></i>
              {{ $t("navbar.kullanici.kullanicirolleri") }}
            </router-link>
          </b-dropdown-item>
            <b-dropdown-item v-if="MenuRoleKontrol">
            <router-link tag="span" to="/ouserbirimyetki">
              <i class="mdi mdi-eye-off font-size-16 align-middle me-1"></i>
              {{ $t("navbar.kullanici.birimrolleri") }}
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item> 
            <router-link tag="span" to="/logout">
              <i
                class="
                  bx bx-power-off
                  font-size-16
                  align-middle
                  me-1
                  text-danger
                "
              ></i>
              {{ $t("navbar.kullanici.cikisyap") }}
            </router-link>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
